// Modules
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';

// Actions
import { alerts } from 'modules/alerts/actions';

// Services
import PurchaseOrder from 'services/data/purchase-order';
import ExpenseBill from 'services/data/expense-bill';

// Components
import ReturnForm from './forms/return-form';


// Component
export default class EditReturn extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentWillMount() {
    // Save the initial form values in the state on mount, because we don't want
    // to reinitialize the form if something about the EB changes while we're editing
    // it (like when it gets set to syncing while saving to the api)
    this.setState({ initialFormValues: getInitialFormValues(this.props.expenseBill) });
  }

  render() {
    const { cancel, updatePurchaseOrder, expenseBill } = this.props;

    return (
      <tr>
        <td colSpan="6" className="form-container return-form-container">
          <ReturnForm
            cancel={this.props.cancel}
            form={`addReturnForm-${expenseBill.id}`}
            initialValues={this.state.initialFormValues}
            header="Edit Return"
            onSubmit={(values) =>
              ExpenseBill.update(formatReturn(values))
                .then(() => PurchaseOrder.findOne(values.purchaseOrderId, PurchaseOrder.defaultQuery))
                .then(updatePurchaseOrder)
                .then(cancel)
                .catch(alerts.catchError)
            }
          />
        </td>
      </tr>
    );
  }
}

// Prop types
EditReturn.propTypes = {
  cancel: PropTypes.func.isRequired,
  expenseBill: PropTypes.object.isRequired,
  updatePurchaseOrder: PropTypes.func.isRequired
};


// Helper functions
function formatReturn(data) {
  const lineItems = _.cloneDeep(_.map(data.lineItems, (lineItem) => {
    if (Number(lineItem.quantity) <= 0) return { id: lineItem.id, status: 'Archived' };
    return lineItem;
  }));

  _.forEach(lineItems, (lineItem) => { lineItem.unitCost = lineItem.unitCost * -1; });

  const lineItemTotal = _.sum(_.map(lineItems, (lineItem) => lineItem.quantity * lineItem.unitCost));
  const shipping = Number(data.shippingType === 'fee' ? data.shipping : data.shipping * -1 || 0);
  const tax = Number(data.tax * -1 || 0);

  return {
    id: data.id,
    purchaseOrder: data.purchaseOrderId,
    date: data.date || moment().toDate(),
    shipping,
    tax,
    receipt: data.receipt,
    amount: lineItemTotal + shipping + tax,
    lineItems
  };
}

function getInitialFormValues(expenseBill) {
  // Switch the shipping, tax, and unit costs to be positive
  return {
    ...expenseBill,
    date: expenseBill.date || moment().toDate(),
    shipping: Math.abs(expenseBill.shipping || 0),
    tax: Math.abs(expenseBill.tax || 0),
    shippingType: expenseBill.shipping > 0 ? 'fee' : 'refund',
    purchaseOrderId: expenseBill.purchaseOrder,
    receipt: [{ name: expenseBill.receipt.filename }],
    lineItems: _.map(expenseBill.lineItems, (lineItem) => ({
      ...lineItem,
      description: lineItem.purchaseOrderLineItem.description,
      billableQuantity: lineItem.purchaseOrderLineItem.unbilledQuantity + lineItem.quantity,
      unitCost: Math.abs(lineItem.unitCost)
    }))
  };
}
